import React from "react";
import { useParams } from "react-router";

import CombinedTrendCard from "./CombinedTrendCard";
import { useTrendsData } from "./hooks/useTrendsData";

const COLOUR_INTERNAL = "#1976d2";
const COLOUR_EXTERNAL = "#455a64";

export default function ScopeSection({ startDate, endDate }) {
    const { workspaceNumber } = useParams();
    const { series } = useTrendsData({ workspaceNumber, startDate, endDate });

    const internal = series((s) => s.crawlScopeStats?.internal ?? 0);
    const external = series((s) => s.crawlScopeStats?.external ?? 0);

    const chartSeries = [
        { label: "Internal", series: internal, stroke: COLOUR_INTERNAL },
        { label: "External", series: external, stroke: COLOUR_EXTERNAL },
    ];

    const tooltip = "Crawl scope composition over time: internal vs external URLs discovered per day.";

    return (
        <CombinedTrendCard
            title="Page crawled"
            tooltip={tooltip}
            startDate={startDate}
            endDate={endDate}
            series={chartSeries}
            showLegend
            remountKey={`scope-${startDate}-${endDate}`}
        />
    );
}
